"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EntityType = exports.EntityTypes = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.EntityTypes = [
    // Order
    'sourgum-order',
    'wayste-order',
    // Invoice
    'sourgum-receivable',
    'sourgum-payable',
    'wayste-receivable',
    // Customer
    'sourgum-customer',
    'wayste-customer',
    'sourgum-lead',
    // Hauler
    'sourgum-vendor',
    // Pricing
    'sourgum-pricing-zone',
    'wayste-pricing-zone',
    // Disposal-Site
    'wayste-disposal-site',
    // Equipment (Dumpster)
    'wayste-dumpster',
    // Audit-Trail
    'audit-log',
    // Internal-Ticket
    'internal-ticket',
    // Product (Universal Services)
    'sourgum-invoice-grouping',
    'sourgum-rfp',
    'sourgum-service-grouping',
    'sourgum-service-order',
    // Commercial
    'wayste-commercial-subscription',
    'wayste-commercial-billing-activity',
    'wayste-commercial-subscription-equipment',
    'wayste-commercial-route-plan-stop',
    'wayste-commercial-route-plan-template-stop',
    // Operations
    'operations-billing-period',
    'operations-order-item',
    'operations-order-commercial',
    'operations-order-ptloo',
    'operations-order-ro',
    'operations-order',
    'operations-subscription',
    'operations-task-group',
    'operations-task-group-dispatch',
    'operations-task-group-images',
];
exports.EntityType = typebox_1.Type.Union(exports.EntityTypes.map((type) => typebox_1.Type.Literal(type)));
//# sourceMappingURL=entity-type.js.map